<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center mb-5">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/tariffs']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">{{ "TARIFFS_MENU_TARIFFSETUP" | translate }}</h2>
      <h6 class="col subtitle">{{ "TARIFFS_SETUP_SUBTITLE" | translate }}</h6>
    </div>
  </div>
  @if(tariffDataService.getTariffDevices().length > 0){

  <!-- preview -->
  <div class="subpage-container pb-4">
    <span class="subtitle ps-5">Added Tariff</span>
    <div class="row g-0 m-0 pt-3 gap-3 pb-3 ps-5 pe-5">
      <div *ngFor="let row of tariffPreviewList; let i = index"
        class="row g-0 p-0 d-flex justify-content-between member-info p-3">

        <!-- Left-->
        <div class="col d-flex p-0 justify-content-start align-items-center">
          <div class="d-inline-flex text bolded" *ngFor="let item of row.values; let i = index">
            <!-- Show line between elements -->
            <span *ngIf="i > 0" class="px-2">|</span>
            <span>{{ item }}</span>
          </div>
        </div>

        <!-- Right-->
        <div class="col-2 d-flex p-0 justify-content-end">
          <div class="d-flex flex-row">
            <!-- Edit  -->
            <div class="d-flex align-items-center me-2 ps-2 pe-2 button-wrapper">
              <svg-icon class="me-1 edit" alt="Edit" src="assets/device/edit.svg"></svg-icon>
              <span class="item-title">Edit</span>
            </div>

            <!-- Delete -->
            <div class="d-flex align-items-center">
              <svg-icon class="me-1" alt="Deactivate" src="assets/core/table/delete.svg"></svg-icon>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row g-0 m-0 pt-2 pb-3 ps-5 pe-5 justify-content-between">
      <div class="col-auto d-flex button-cancel align-items-center" (click)="addAnotherDevice()">
        <span>{{ "TARIFF_PREVIEW_ADD_ANOTHER_TARIFF" | translate }} +</span>
      </div>
      <div class="col-auto add">
        <span>{{"TARIFF_PREVIEW_SAVE_ADDED_TARIFF" | translate }}</span>
      </div>
    </div>
  </div>
  }


  <form *ngIf="!hideAdd" form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="serviceName">{{ "TARIFFSETUP_TARIFFNAME" | translate }}:</label>
      <div class="form-input">
        <input id="serviceName" [(ngModel)]="data.serviceName" name="serviceName" #serviceName="ngModel" type="text"
          required />
        @if (crudform.submitted && serviceName.invalid) {
        <div class="validation-error">
          {{ "TARIFFSETUP_TARIFFNAME" | translate }}
          {{ "TARIFFSETUP_IS_REQUIRED" | translate }}.
        </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="tariffServiceType">{{ "DEVICESETUP_SERVICETYPE" | translate }}:</label>
      <div class="custom-div">
        <div class="radio-div custom-radio-div">
          <div class="element" *ngFor="let item of tariffServiceType">
            <span class="radiobox" (click)="data.tariffServiceType = item"
              [ngClass]="{ selected: data.tariffServiceType === item }">
              {{ item }}
              <input id="{{item}}" type="radio" name="tariffServiceType" [(ngModel)]="data.tariffServiceType"
                [value]="item" required />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (data.tariffServiceType === null) {
        <div class="second-subitem" class="validation-instruction">
          {{ "TARIFFETUP_SERVICETYPEDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="tariffCustomerType">{{ "TARIFFSETUP_CUSTOMERTYPE" | translate }}:</label>
      <div class="custom-div">
        <div class="radio-div custom-radio-div">
          <div class="element" *ngFor="let item of tariffCustomerType">
            <span class="radiobox" (click)="data.tariffCustomerType = item"
              [ngClass]="{ selected: data.tariffCustomerType === item }">
              {{ item }}
              <input id="{{item}}" type="radio" name="tariffCustomerType" [(ngModel)]="data.tariffCustomerType"
                [value]="item" required />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (data.tariffCustomerType === null) {
        <div class="second-subitem" class="validation-instruction">
          {{ "TARIFFSETUP_CUSTOMERTYPEDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <div class="form-item" *ngIf="data.tariffServiceType === 'Prepaid' && data.tariffCustomerType === 'NSLT'">
      <label class="form-label" for="tariffClassCategory"></label>
      <div class="custom-divAbove">
        <div class="validation-instruction">
          {{ "TARIFFSETUP_CLASS_CATEGORY_DESC" | translate }}
        </div>
        <div class="radio-div custom-radio-div">
          <div class="element" *ngFor="let item of tariffClassCategory">
            <span class="radiobox" (click)="data.tariffClassCategory = item"
              [ngClass]="{ selected: data.tariffClassCategory === item }">
              {{ item }}
              <input id="{{item}}" type="radio" name="tariffClassCategory" [(ngModel)]="data.tariffClassCategory"
                [value]="item" required />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (data.tariffCustomerType === null) {
        <div class="second-subitem" class="validation-instruction">
          {{ "TARIFFSETUP_CUSTOMERTYPEDESC" | translate }}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line"></div>
    <!-- Tariff band-->
    <div class="form-item">
      <label class="form-label" for="tariffBand">{{ "TARIFFSETUP_TARIFFBAND" | translate }}:</label>
      <div class="custom-div">
        <div class="radio-div custom-radio-div">
          <div class="element" *ngFor="let item of tariffBand">
            <span class="radiobox" (click)="data.tariffBand = item" [ngClass]="{ selected: data.tariffBand === item }">
              {{ item }}
              <input id="{{item}}" type="radio" name="tariffBand" [(ngModel)]="data.tariffBand" [value]="item"
                required />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (data.tariffBand === null) {
        <div class="second-subitem" class="validation-instruction">
          {{ "TARIFFSETUP_TARIFFBANDDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <!-- active period -->
    <div class="horizontal-line" *ngIf="data.tariffBand === 'Single' || data.tariffBand === 'Multiple'"></div>

    <div class="form-item" *ngIf="data.tariffBand === 'Single' || data.tariffBand === 'Multiple'">
      <label class="form-label">{{ "TARIFFSETUP_ACTIVEPERIOD" | translate }}:</label>
      <div class="date-column">
        <!-- Start Date -->
        <div class="date-container" (click)="toggleStartDatepicker()">
          <span class="ps-4 pe-4">{{ "TARIFFSETUP_ACTIVEPERIODFROMDATE" | translate }}</span>
          <div class="date-input">
            <input id="tariffActivePeriodStartDate" [(ngModel)]="selectedStartDate"
              #tariffActivePeriodStartDate="ngModel" name="tariffActivePeriodStartDate" type="text"
              placeholder="DD/MM/YYYY" readonly required />
            <img alt="Calendar" src="assets/device/calendar.svg" />
          </div>
        </div>
        @if (isStartDatepickerShown) {
        <div class="overlay-light" (click)="toggleStartDatepicker()"></div>
        <app-future-datepicker [scale]="1.1" [range]="false" [inputFromDate]="data.tariffActivePeriodStartDate"
          (dateRangeChanged)="onStartDateRangeChanged($event)"></app-future-datepicker>
        }
        @if (crudform.submitted && tariffActivePeriodStartDate.invalid) {
        <div class="validation-error">
          {{ "TARIFFSETUP_ACTIVEPERIODFROMDATEDESC" | translate }}
          {{ "TARIFFSETUP_IS_REQUIRED" | translate }}.
        </div>
        } @else if (tariffActivePeriodStartDate.invalid) {
        <div class="validation-instruction">
          {{ "TARIFFSETUP_ACTIVEPERIODFROMDATEDESC" | translate }}
        </div>
        }
      </div>

      <!-- End Date -->
      <div class="date-column">
        <div class="date-container" (click)="toggleEndDatepicker()">
          <span class="ps-4 pe-4">{{ "TARIFFSETUP_ACTIVEPERIODTODATE" | translate }}</span>
          <div class="date-input">
            <input id="tariffActivePeriodEndDate" [(ngModel)]="selectedEndDate" #tariffActivePeriodEndDate="ngModel"
              name="tariffActivePeriodEndDate" type="text" placeholder="DD/MM/YYYY" readonly />
            <img alt="Calendar" src="assets/device/calendar.svg" />
          </div>
        </div>
        @if (isEndDatepickerShown) {
        <div class="overlay-light" (click)="toggleEndDatepicker()"></div>
        <app-future-datepicker #d [scale]="1.1" [range]="false" [inputFromDate]="data.tariffActivePeriodEndDate"
          (dateRangeChanged)="onEndDateRangeChanged($event)"></app-future-datepicker>
        }
        @if (!tariffActivePeriodEndDate.valid && tariffActivePeriodEndDate.touched) {
        <div class="validation-instruction">
          {{ "TARIFFSETUP_ACTIVEPERIODTODATEDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <!-- Date Range Validation Error -->
    @if (dateRangeError) {
    <div class="validation-error" style="margin-top: 12px;">
      {{ dateRangeError }}
    </div>
    }

    <!-- Tariff Rate-->
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffRate">{{ "TARIFFSETUP_RATE" | translate }}:</label>
      <div class="form-input">
        <input id="tariffRate" [(ngModel)]="data.tariffRate" #tariffRate="ngModel" name="tariffRate" type="text"
          maxlength="32" pattern="^\d+(\.\d{1,3})?$" required />
        @if (crudform.submitted && tariffRate.invalid) {
        <div class="validation-error">
          @if (tariffRate.errors?.['required']) {
          {{ "TARIFFSETUP_RATE" | translate }} {{ "TARIFFSETUP_IS_REQUIRED" | translate }}.
          } @else if (tariffRate.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffRate.valid && tariffRate.touched) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>

    <!-- Service Change Rate -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffServiceChangeRate">{{ "TARRIFSETUP_SERVICE_CHANGE_RATE" | translate
        }}:</label>
      <div class="form-input">
        <input id="tariffServiceChangeRate" [(ngModel)]="data.tariffServiceChangeRate"
          #tariffServiceChangeRate="ngModel" name="tariffServiceChangeRate" type="text" maxlength="32"
          pattern="^\d+(\.\d{1,3})?$" required />
        @if (crudform.submitted && tariffServiceChangeRate.invalid) {
        <div class="validation-error">
          @if (tariffServiceChangeRate.errors?.['required']) {
          {{ "TARIFFSETUP_RATE" | translate }} {{ "TARIFFSETUP_IS_REQUIRED" | translate }}.
          } @else if (tariffServiceChangeRate.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffServiceChangeRate.valid && tariffServiceChangeRate.touched) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>

    <!-- Max Demand Rate -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffMaxDemandRate">{{ "TARRIFSETUP_MAX_DEMAND_RATE" | translate }}:</label>
      <div class="form-input">
        <input id="tariffMaxDemandRate" [(ngModel)]="data.tariffMaxDemandRate" #tariffMaxDemandRate="ngModel"
          name="tariffMaxDemandRate" type="text" maxlength="32" pattern="^\d+(\.\d{1,3})?$" required />
        @if (crudform.submitted && tariffMaxDemandRate.invalid) {
        <div class="validation-error">
          @if (tariffMaxDemandRate.errors?.['required']) {
          {{ "TARIFFSETUP_RATE" | translate }} {{ "TARIFFSETUP_IS_REQUIRED" | translate }}.
          } @else if (tariffMaxDemandRate.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffMaxDemandRate.valid && tariffMaxDemandRate.touched) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>

    <!-- Government Levy -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffGovernmentLevy">{{ "TARIFFSETUP_GOVERNMENT_LEVY" | translate }}:</label>
      <div class="form-input">
        <div class="form-label">{{"TARIFFSETUP_RATE" | translate }}</div>
        <input id="tariffGovernmentLevy" [(ngModel)]="data.tariffGovernmentLevy" #tariffGovernmentLevy="ngModel"
          name="tariffGovernmentLevy" type="text" maxlength="32" pattern="^\d+(\.\d{1,3})?$" />
        @if (crudform.submitted && tariffGovernmentLevy.invalid) {
        <div class="validation-error">
          @if (tariffGovernmentLevy.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffGovernmentLevy.valid && tariffGovernmentLevy.touched && tariffGovernmentLevy.value) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>

    <!-- Street Lighting -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffStreetLighting">{{ "TARIFFSETUP_STREET_LIGHTING" | translate }}:</label>
      <div class="form-input">
        <div class="form-label">{{"TARIFFSETUP_RATE" | translate }}</div>
        <input id="tariffStreetLighting" [(ngModel)]="data.tariffStreetLighting" #tariffStreetLighting="ngModel"
          name="tariffStreetLighting" type="text" maxlength="32" pattern="^\d+(\.\d{1,3})?$" />
        @if (crudform.submitted && tariffStreetLighting.invalid) {
        <div class="validation-error">
          @if (tariffStreetLighting.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffStreetLighting.valid && tariffStreetLighting.touched && tariffStreetLighting.value) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>
    <!-- VAT -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffVat">{{ "TARIFFSETUP_VAT" | translate }}:</label>
      <div class="form-input">
        <div class="form-label">{{"TARIFFSETUP_RATE" | translate }}</div>
        <input id="tariffVat" [(ngModel)]="data.tariffVat" #tariffVat="ngModel" name="tariffVat" type="text"
          maxlength="32" pattern="^\d+(\.\d{1,3})?$" />
        @if (crudform.submitted && tariffVat.invalid) {
        <div class="validation-error">
          @if (tariffVat.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffVat.valid && tariffVat.touched && tariffVat.value) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>
    <!-- NHL & GetFund -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffNhlAndGetFund">{{ "TARIFFSETUP_NHL_AND_GET_FUND" | translate }}:</label>
      <div class="form-input">
        <div class="form-label">{{"TARIFFSETUP_RATE" | translate }}</div>
        <input id="tariffNhlAndGetFund" [(ngModel)]="data.tariffNhlAndGetFund" #tariffNhlAndGetFund="ngModel"
          name="tariffNhlAndGetFund" type="text" maxlength="32" pattern="^\d+(\.\d{1,3})?$" />
        @if (crudform.submitted && tariffNhlAndGetFund.invalid) {
        <div class="validation-error">
          @if (tariffNhlAndGetFund.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffNhlAndGetFund.valid && tariffNhlAndGetFund.touched && tariffNhlAndGetFund.value) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>
    <div class="horizontal-line" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError"></div>
    <!-- Subsidy -->
    <div class="form-item" *ngIf="data.tariffActivePeriodStartDate != null && !dateRangeError">
      <label class="form-label" for="tariffSubsidy">{{ "TARIFFSETUP_SUBSIDY" | translate }}:</label>
      <div class="form-input">
        <div class="form-label">{{"TARIFFSETUP_RATE" | translate }}</div>
        <input id="tariffSubsidy" [(ngModel)]="data.tariffSubsidy" #tariffSubsidy="ngModel" name="tariffSubsidy"
          type="text" maxlength="32" pattern="^\d+(\.\d{1,3})?$" />
        @if (crudform.submitted && tariffSubsidy.invalid) {
        <div class="validation-error">
          @if (tariffSubsidy.errors?.['pattern']) {
          {{ "TARIFFSETUP_ERROR_RATE_DESC" | translate }}
          }
        </div>
        } @else if (!tariffSubsidy.valid && tariffSubsidy.touched && tariffSubsidy.value) {
        <div class="validation-instruction">
          {{"TARIFFSETUP_RATE_ERROR" | translate}}
        </div>
        }
      </div>
    </div>

    <!-- Tariff Preview Components Section -->
    @if(data.tariffActivePeriodStartDate != null && !dateRangeError){
    <!-- <div class="horizontal-line"></div>
    @for(label of tariffLabels; track label; let i = $index){
      <app-tariff-preview [leftLabel]="label" class="form-tem"></app-tariff-preview>
    } -->
    }

    @if(data.tariffActivePeriodStartDate == null || dateRangeError){
    <div class="horizontal-line"></div>
    }

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid || dateRangeError" type="submit">
        {{ "TARIFFSETUP_FINISH_SETUP" | translate }}
      </button>
      <div [routerLink]="['/tariffs']">
        <button class="button-cancel" type="button">
          {{ "TARIFFSETUP_CANCEL_SETUP" | translate }}
        </button>
      </div>
    </div>
  </form>